import { cva } from 'class-variance-authority';

export const badgeVariants = cva(
  'inline-flex items-center justify-center rounded-md border text-xxs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden h-[fit-content]',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground [a&]:hover:bg-primary/90',
        outline: 'text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground',
        success:
          'bg-[#5392731A] text-[#5DB489] text-[12px] p-1 rounded-[8px] flex items-center justify-between border-none',
        white:
          'bg-white text-black text-[12px] px-2 py-1 rounded-[32px] flex items-center justify-between border-none font-bold',
        ultimateOrange:
          'bg-[#ee9e10] text-white uppercase text-[12px] px-2 py-1 rounded-[32px] flex items-center justify-between border-none font-bold',
        grey: 'bg-white/20 text-white border-none px-2 py-1 rounded-[32px] font-bold text-sm',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);
